export default[{
        path: '/expenses',
        name: 'expenses',
        component: () =>
            import ('@/views/pages/expenses/expenses-list/ExpensesList.vue'),
        meta: {
            pageTitle: 'Expenses',
            breadcrumb: [{
                text: 'Expenses',
                active: true,
                to: '/expenses'
            }],
            resource: 'invoice',
            action: 'read'
        }
    },
    {
        path: '/expenses/view/:id',
        name: 'expenses-view',
        component: () =>
            import ('@/views/pages/expenses/expenses-view/ExpensesView.vue'),
        meta: {
            pageTitle: 'View Expense',
            breadcrumb: [
            {
                text: 'Expenses',
                to: '/expenses',
            },{
                text: 'View',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        },
    },
    {
        path: '/expenses/edit/:id',
        name: 'expenses-edit',
        component: () =>
            import ('@/views/pages/expenses/expenses-edit/ExpensesEdit.vue'),
        meta: {
            pageTitle: 'Edit Expense',
            breadcrumb: [
            {
                text: 'Expenses',
                to:'/expenses',
            },
            {
                text: 'Edit',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        },
    },
    {
        path: '/expenses/add',
        name: 'expenses-add',
        component: () =>
            import ('@/views/pages/expenses/expenses-add/ExpensesAdd.vue'),
        meta: {
            pageTitle: 'Add Expense',
            breadcrumb: [{
                text: 'Expenses',
                to: '/expenses',
            },
            {
                text: 'Add',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        }
    }
]